export const DASHBOARD_BLOCKS = [
  { id: "kpis", label: "KPI cards (total, open, pending, resolved, SLA, CSAT)" },
  { id: "low_ratings", label: "Low customer ratings list" },
  { id: "speed", label: "Average response and resolution time" },
  { id: "agent_of_month", label: "Agent of the Month (top solver card)" },
  { id: "leaderboard", label: "Top agents - most active, most tickets handled, most solved" },
  { id: "trend", label: "Trend chart - last 7 days" },
  { id: "status", label: "Tickets by status (donut)" },
  { id: "priority", label: "Tickets by priority" },
  { id: "category", label: "Tickets by category" },
  { id: "technician", label: "Tickets by technician" },
  { id: "recent", label: "Recent tickets" },
];

export const normalizeLayout = (saved) => {
  const known = DASHBOARD_BLOCKS.map((b) => b.id);
  const list = (saved || []).filter((b) => known.includes(b.id));
  known.forEach((id) => { if (!list.find((b) => b.id === id)) { list.push({ id, visible: true }); } });
  return list.map((b) => ({ id: b.id, visible: b.visible !== false }));
};
